import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import React, { useEffect, useState } from 'react';
import jwt_decode from 'jwt-decode';
import { UnauthorizedScopePage } from 'Pages/Error/UnauthorizedScopePage/UnauthorizedScopePage';


const ProtectedRoute = ({
	component, permissions,
	...args
}: any) => {
	const { getAccessTokenSilently } = useAuth0();
	const Protected = withAuthenticationRequired(component, args);
	const [state, setState] = useState('loading');
	
	const validatePermissions = async () => {
		if (!permissions) {
			setState('allowed');
			return;
		}

		const data = await getAccessTokenSilently();
		const decodedToken: any = jwt_decode(data);
		
		if (permissions?.every(i => decodedToken?.permissions?.includes(i))) {
			setState('allowed');
			return;
		}
		
		setState('disallowed');
	}

	useEffect(() => {
		validatePermissions();
	}, []);

	// @ts-ignore
	// if (window?.Cypress) {
	// 	return React.createElement(component, {...args});
	// }

	if (!permissions || state === 'allowed') {
		return <Protected />;
	}
	
	return <UnauthorizedScopePage />;
};

export default ProtectedRoute;